import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
// Side-effect only: attaches the beforeinstallprompt listener before the first
// render. The event fires once per page load and is lost if nothing has
// subscribed yet, so this must load ahead of any component that reads it.
import './utils/installPrompt';

// Query strings can carry credential material: the password-reset token
// (/reset-password?token=…, valid 1h and NOT consumed until the form is
// submitted) and the magic-link token (/auth/verify?token=…). PostHog records
// window.location.href as $current_url on every event, which would put live
// credentials in a third-party event store. Allowlist the campaign tags
// analytics actually needs and drop every other param, so a future
// token-bearing URL is covered without anyone remembering to update this.
const ANALYTICS_QUERY_ALLOWLIST = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
  'gclid', 'fbclid', 'msclkid',
];

function scrubUrl(value) {
  if (typeof value !== 'string') return value;
  let url;
  try {
    // Relative values resolve against the origin; non-URLs like the "$direct"
    // sentinel PostHog uses for $referrer throw and pass through untouched.
    url = new URL(value, window.location.origin);
  } catch {
    return value;
  }
  if (!url.search) return value;
  const kept = new URLSearchParams();
  ANALYTICS_QUERY_ALLOWLIST.forEach((key) => {
    const v = url.searchParams.get(key);
    if (v !== null) kept.append(key, v);
  });
  url.search = kept.toString();
  return url.toString();
}

// Scrub by key name rather than a fixed list, so $current_url, $referrer,
// $initial_referrer and any future variant are all covered.
function scrubUrlProperties(props) {
  if (!props) return props;
  Object.keys(props).forEach((key) => {
    if (/url|referrer/i.test(key)) props[key] = scrubUrl(props[key]);
  });
  return props;
}

// Runs on every event before it leaves the browser — pageview, autocapture and
// named captures alike. $set/$set_once are included because PostHog stores
// initial-touch URLs as person properties, which would otherwise keep a
// permanent copy of a tokened URL on the person record.
function stripCredentialsFromUrls(event) {
  if (!event) return event;
  scrubUrlProperties(event.properties);
  scrubUrlProperties(event.$set);
  scrubUrlProperties(event.$set_once);
  return event;
}

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: true,
    before_send: stripCredentialsFromUrls,
  });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
